import { render, staticRenderFns } from "./updates.vue?vue&type=template&id=51d286fe&scoped=true"
import script from "./updates.vue?vue&type=script&lang=js"
export * from "./updates.vue?vue&type=script&lang=js"
import style0 from "./updates.vue?vue&type=style&index=0&id=51d286fe&prod&lang=scss&scoped=true"
import style1 from "./updates.vue?vue&type=style&index=1&id=51d286fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d286fe",
  null
  
)

export default component.exports